// extracted by mini-css-extract-plugin
export default {"noizeScale":"NoizeScale_noizeScale__66v05"};